var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenSourceIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 13.8971 18.6311 16.4746 16.5048 18.1207L14.9449 15.5209C16.2043 14.421 17 12.8034 17 11C17 7.68629 14.3137 5 11 5C7.68629 5 5 7.68629 5 11C5 12.8136 5.80462 14.4392 7.07636 15.5394L5.51732 18.1378C3.37841 16.4924 2 13.9072 2 11ZM12.45 14.7291C13.9424 14.1484 15 12.6977 15 11C15 8.79086 13.2091 7 11 7C8.79086 7 7 8.79086 7 11C7 12.8007 8.18982 14.3234 9.82614 14.825L6.18124 20.8911C2.5213 19.1047 0 15.3468 0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11C22 15.2446 19.5958 18.9277 16.0749 20.7619L12.45 14.7291Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenSourceIcon);
export default __webpack_public_path__ + "static/media/open-source-icon.4d0956dd8e8431ce82e39bcb3243f496.svg";
export { ForwardRef as ReactComponent };